/*
 * SPDX-FileCopyrightText: 2020 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: GPL-3.0-or-later
 */
import ScopedStorage from "./ScopedStorage.js";
export default class StorageBuilder {
    appId;
    persisted = false;
    clearedOnLogout = false;
    constructor(appId) {
        this.appId = appId;
    }
    persist(persist = true) {
        this.persisted = persist;
        return this;
    }
    clearOnLogout(clear = true) {
        this.clearedOnLogout = clear;
        return this;
    }
    build() {
        return new ScopedStorage(this.appId, this.persisted ? window.localStorage : window.sessionStorage, !this.clearedOnLogout);
    }
}
